<template>
  <div class="qRcodePop">
    <div class="qRcode">
      <div class="title">电子发票</div>
      <div class="img">
        <img src="./getTmpQrCode.jpg" />
      </div>
      <div class="explain">使用微信扫码查看您的电子发票</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'electronicInv',
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.qRcodePop {
  position: fixed;
  left: 0;
  top: 0;
  text-align: center;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);

  .qRcode {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0 15px;
    background-color: rgba(0, 0, 0, 0.5);

    .title {
      font-size: 8px;
      height: 22px;
      line-height: 22px;
      color: #ffffff;
    }

    .img {
      img {
        width: 95%;
      }
    }

    .explain {
      font-size: 5px;
      height: 22px;
      line-height: 18px;
      color: #ffffff;
    }
  }
}
</style>